import { Grid, Stack, Typography, useTheme } from '@mui/material';
import loginPageImage1 from 'assets/images/auth/auth-image-1.png';
import loginPageImage2 from 'assets/images/auth/auth-image-2.png';
import loginPageImage3 from 'assets/images/auth/auth-image-3.png';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import LocalizationSection from '../MainLayout/Header/LocalizationSection';

// ==============================|| AUTHENTICATION CARD WRAPPER ||============================== //

const getRandomNumber = (max: number) => Math.floor(Math.random() * max); // gets random number in range [0, max - 1]
const images = [loginPageImage1, loginPageImage2, loginPageImage3];

const AuthCardWrapper = ({ children }) => {
  const theme = useTheme();
  const [imageIndex, setImageIndex] = useState(getRandomNumber(3));

  return (
    <Grid container sx={{ height: '100vh', width: '100vw', p: 0, m: 0, boxSizing: 'border-box', overflow: 'hidden' }}>
      <Grid
        item
        xs={6}
        sx={{
          p: 0,
          m: 0,
          display: {
            xs: 'none',
            sm: 'block'
          }
        }}
      >
        <img
          loading="lazy"
          src={images[imageIndex]}
          style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'filter 0.5s ease' }}
          alt="auth-page"
        />
      </Grid>
      <Grid item xs={12} sm={6} sx={{ height: '100%', display: 'flex', flexDirection: 'column', overflow: 'auto' }}>
        <Stack sx={{ justifyContent: 'flex-end', alignItems: 'flex-end', pt: 4, pr: '18.5%' }}>
          <LocalizationSection />
        </Stack>

        {children}
        <Typography textAlign="center" sx={{ mt: 'auto', p: theme.spacing(2) }}>
          {new Date().getFullYear()} &#169;
          <FormattedMessage defaultMessage="NousTalk, All Rights Reserved" />
        </Typography>
      </Grid>
    </Grid>
  );
};

export default AuthCardWrapper;
